import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./individual-streets.scss";
import {UseState} from "../../../../../../../../../react/use-state";
import {chain} from "../../../../../../../../../utils/fs";
import {flatten1} from "../../../../../../../../../utils/collections";
import {SearchInput} from "../../../../../../../common/design2/search-input/search-input";
import {Table} from "./table/table";
import {scc} from "../../../../../../../../../react/state-cascade-change";
import {plural} from "../../../../../../../../language/plural";

export const IndividualStreets = ({searching, data}) => cs(
    () => (
        <div className="individual-streets-1qz">
            <div className="separator"/>

            {cs(
                ["filter", (_, next) => UseState({next})],
                ["match", ({filter}, next) => next(!filter.value? (() => true) : (() => {
                    const lowerCase = filter.value.toLowerCase();
                    return (r) => (
                        r.address.address.toLowerCase().includes(lowerCase) ||
                        ("" + r.address.sort_house).startsWith(lowerCase)
                    );
                })())],

                ["records", ({}, next) => next(
                    searching.type === "all" ? (
                        chain(
                            data.value,
                            (streets) => {
                                let addressSortIndex = 0;
                                return streets.map((r) => {
                                    const clonedRow = r.addresses.slice(0).sort((a,b) => +a.address.split(' ', 1)[0] - +b.address.split(' ', 1)[0]);
                                    addressSortIndex += clonedRow.length;
                                    return clonedRow.map((address, i) => ({
                                        address,
                                        parentRecord: r,
                                        addressSortKey: i + (addressSortIndex - clonedRow.length),
                                    }));
                                });
                            },
                            flatten1,
                        )
                    ) : (
                        chain(
                            data.value.find((r) => r.key === searching.streetKey),
                            (row) => ({
                                ...row,
                                addresses: row.addresses.slice(0).sort((a,b) => +a.address.split(' ', 1)[0] - +b.address.split(' ', 1)[0]),
                                parentRecord: row,
                            }),
                            (r) => r.addresses.map((address, i) => ({
                                address,
                                parentRecord: r.parentRecord,
                                addressSortKey: i,
                            }))
                        )
                    )
                )],
                ["filteredRecords", ({records, match}, next) => next(records.filter(match))],
                ["isExcluded", (_, next) => next((addrRecord) => addrRecord.address.display_address == 0)],

                ({filter, records, filteredRecords, isExcluded}) => <>
                    <div className="header">
                        <div className="text">
                            <div className="title" xd-qa-type="label" xd-qa-name="Build Street List Addresses On">
                                Addresses on: {searching.type === "all" ? "All" : data.value.find((s) => s.key === searching.streetKey).street.address}
                            </div>
                            <div className="sub-title" xd-qa-type="label" xd-qa-name="Build Street List Addresses On Description">
                                Uncheck addresses you wish to remove from the list.
                            </div>
                        </div>
                        <div className="controls">
                            {SearchInput({
                                state: filter,
                                placeholder: "Search Address",
                                text: filter.value && <>Found <b>{filteredRecords.length}</b> {plural("address", filteredRecords.length)}</>,
                                xdQaName: "Build Street List Search Address"
                            })}
                        </div>
                    </div>

                    <div className="box">
                        {Table({
                            records: filteredRecords,
                            count: {
                                total: records.length,
                                selected: records.filter((addr) => !isExcluded(addr)).length,
                            },
                            loading: data.loading,
                            masterCheckbox: (
                                !filteredRecords.find((r) => !isExcluded(r)) ? {
                                    checked: false,
                                    onClick: () => removeExcludedRecords({records: filteredRecords, data}),
                                } : filteredRecords.find((r) => isExcluded(r)) ? {
                                    checked: "midway",
                                    onClick: () => removeExcludedRecords({records: filteredRecords, data}),
                                } : {
                                    checked: true,
                                    onClick: () => addExcludedRecords   ({records: filteredRecords, data}),
                                }
                            ),
                            getCheckbox: (r) => ({...{
                                checked: !isExcluded(r),
                                disabled: r.address.doNotMail,
                                onClick: () => !r.address.doNotMail && setExcludedRecords(!isExcluded(r) ? 0 : 1, {records: [r], data}),
                                xdQaName: "Build Street List "+r.address.address,
                            }}),
                        })}
                    </div>
                </>
            )}
        </div>
    ),
);


const removeExcludedRecords = ({records, data}) => setExcludedRecords(1, {records, data});
const addExcludedRecords    = ({records, data}) => setExcludedRecords(0, {records, data});

const setExcludedRecords = (value, {records, data}) => (
    scc(data, "[*].addresses[*].display_address", (_, {}, {0: r, 2: address}) => (
        !records.find((addressRecord) => addressRecord.parentRecord === r && addressRecord.address === address) ? _ : value
    ))
);